export const TEST_ID = 'droneNameField';
